var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgStarFill = function SvgStarFill(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7236023,8.17921956 L66.1645065,26.7939875 C67.2865349,29.0008361 69.4512561,30.5345958 71.9559859,30.8876916 L93.0478498,33.8669372 C99.3606752,34.7607109 101.876739,42.3081332 97.3092905,46.6445907 L82.042906,61.1325518 C80.2295276,62.8538938 79.402173,65.3365984 79.8328507,67.7641318 L83.4369415,88.2216183 C84.513635,94.3456232 77.9174692,99.0131085 72.2733271,96.1221364 L53.4028521,86.467174 C51.1607097,85.3196078 48.4821475,85.3196078 46.2400051,86.467174 L27.36953,96.1221364 C21.725388,99.0131085 15.1292219,94.3456232 16.2059158,88.2216183 L19.8100064,67.7641318 C20.2406839,65.3365984 19.4133298,62.8538936 17.5999508,61.1325518 L2.33356663,46.6556249 C-2.23388166,42.3191675 0.282181656,34.7717451 6.5950072,33.8779715 L27.6868714,30.8987259 C30.1916012,30.5456302 32.3563222,29.0118704 33.4783506,26.8050217 L42.9305885,8.17921956 C45.7526595,2.60692681 53.9015313,2.60692681 56.7236023,8.17921956 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgStarFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "star-fill.9de4a851798d479351084ae45a768d9c.svg";